/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import apiServices from '../services/apiServices'

function IframeContainer() {
  const ref = useRef()

  const [size, setSize] = useState({
    // width: 600,
    // height: 450,
  })
  const getSize = () => {
    if (ref.current) {
      const width = ref.current.clientWidth - 50
      const height = ref.current.clientHeight - 10
      return { width, height }
    }
    return false
  }
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const newSize = getSize()
      if (newSize.width !== size.width || newSize.height !== size.height)
        setSize(newSize)
    })
    observer.observe(ref.current)
    return () => ref.current && observer.unobserve(ref.current)
  }, [])

  const [revive, setrevive] = useState({
    campaigns: [],
    banners: [],
    insights: {},
    zones: [],
    clients: [],
    az: [],
  })
  const { campaigns, banners, insights } = revive
  const getRevive = async () => {
    const res = await apiServices.data({
      path: `revive`,
      method: 'get',
    })
    // console.log(res)
    setrevive(res)
  }
  useEffect(() => {
    getRevive()
  }, [])

  const fields = [
    'clicks',
    'conversions',
    'impressions',
    'requests',
    'total_basket_value',
    'total_cost',
    'total_num_items',
    'total_revenue',
    'total_techcost',
  ]

  return (
    <div className="h-100 w-100 position-relative overflow-auto p-4" ref={ref}>
      {/* <div
        className="position-absolute w-100"
        style={{
          bottom: 10,
          height: '25px',
          backgroundColor: '#fff',
        }}
      /> */}
      <Row
        className="flex-nowrap col-adjust-1 sticky-top bg-white"
        style={{ top: 0, zIndex: 1000 }}
      >
        <Col xs={3} />
        {fields.map((f) => (
          <Col key={f} xs={1} className="fw-bold text-dai">
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="button-tooltip-2">{f}</Tooltip>}
            >
              <span className="ms-1">{f}</span>
            </OverlayTrigger>
          </Col>
        ))}
      </Row>

      {campaigns.map((campaign) => (
        <React.Fragment key={campaign.campaignid}>
          <Row className="flex-nowrap col-adjust">
            <Col
              className="fw-bold text-start border-top mt-3"
              title={campaign.campaignname}
              xs={3}
            >
              {campaign.campaignname}
            </Col>
            {fields.map((f) => (
              <Col className="border-top mt-3" key={f} xs={1}>
                {insights[campaign.campaignid]
                  ? Number(insights[campaign.campaignid].summary[f]) === '0.00'
                    ? '0.00'
                    : Number(insights[campaign.campaignid].summary[f]).toFixed(
                        2
                      )
                  : '0.00'}
              </Col>
            ))}
          </Row>
          {banners
            .filter((banner) => banner.campaignid === campaign.campaignid)
            .map((banner) => (
              <Row className="flex-nowrap col-adjust" key={banner.bannerid}>
                <Col className="text-start" xs={3}>
                  -&ensp;{banner.description}
                </Col>
                {fields.map((f) => (
                  <Col key={f} xs={1}>
                    {insights[campaign.campaignid] &&
                    insights[campaign.campaignid][banner.bannerid]
                      ? Number(
                          insights[campaign.campaignid][banner.bannerid][f]
                        ) === '0.00'
                        ? '0.00'
                        : Number(
                            insights[campaign.campaignid][banner.bannerid][f]
                          ).toFixed(2)
                      : '0.00'}
                  </Col>
                ))}
              </Row>
            ))}
        </React.Fragment>
      ))}
      <Row />
      {/* {size.height && (
        <iframe
          title="frame"
          width={size.width}
          height={size.height}
          src="https://lookerstudio.google.com/embed/reporting/a560e96a-03ad-41bb-a773-a04f55aab23e/page/cQa7D"
          frameBorder="0"
          // style="border:0"
          allowfullscreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin"
        />
      )} */}
    </div>
  )
}

function Report() {
  return <IframeContainer />
}

export default Report
